import React from 'react';
import MapComponent from './MapComponent';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/icon.svg" alt="Red Rocket icon" className="app-icon"/>
        <h1 className="app-title">Red Rocket Projects</h1>
      </header>
      <MapComponent />
    </div>
  );
}

export default App;
